// extracted by mini-css-extract-plugin
export default {"container":"ToggleButton_container__vDKoa","label":"ToggleButton_label__YygxD"};